import type { RfqStatus } from '@/types/generated';

/**
 * Status colours for a request, shared by the queue and the request's own page.
 *
 * One map rather than two, because a request that reads amber in the list and grey on its own page
 * is a request the reader stops trusting either view of.
 *
 * In its own module rather than beside a component so fast refresh keeps working — a file that
 * exports both a component and a constant is reloaded wholesale on every edit.
 */
export const RFQ_STATUS_COLOUR: Record<
  RfqStatus,
  'default' | 'info' | 'warning' | 'success' | 'error'
> = {
  draft: 'default',
  submitted: 'info',
  quoted: 'warning',
  won: 'success',
  lost: 'error',
  expired: 'default',
  cancelled: 'default',
};
